module.exports = __webpack_public_path__ + "img/warning.34384c3b.svg";